import { QueryCache, QueryClient } from '@tanstack/react-query';
import { Logger } from 'utils/logger';

export const queryCache = new QueryCache({
  onError: (error) => {
    Logger.error({
      message: 'Query Cache Error: ',
      data: error,
    });
  },
});

/**
 * Create a new query client instance
 */
export const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
    },
    mutations: {
      onError(error) {
        Logger.error({ message: 'Mutation Error: ', data: error });
      },
    },
  },
});
